<template>
  <el-dialog
    v-drag
    v-loading="loading"
    :title="`${editTableData.length > 0 ? '修改' : '新增'}派送方式`"
    :visible.sync="dialogVisible"
    width="1000px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <BaseTable
        :height="320"
        :tableData="tableData"
        :isPager="false"
        :isEmptyBorder="true"
      >
        <template slot="type" slot-scope="row">
          <el-select
            v-model="row.scope.type"
            placeholder="请选择"
            :disabled="editTableData.length > 0"
            style="width: 100%"
            @change="
              (e) => {
                change(row.tIndex);
              }
            "
          >
            <el-option
              v-for="item in sendwayOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
        <template slot="containerId" slot-scope="row">
          <el-select
            v-model="row.scope.containerId"
            filterable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in contanierOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
        <template slot="code" slot-scope="row">
          <el-select
            v-model="row.scope.code"
            filterable
            :disabled="row.scope.type !== 3 && row.scope.type !== 2"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in row.scope.codeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
        <template slot="qty" slot-scope="row">
          <el-input
            v-model="row.scope.qty"
            placeholder="请输入件数"
            oninput="value=value.replace(/[^0-9]/g, '')"
            style="width: 100%"
          />
        </template>
        <template slot="square" slot-scope="row">
          <el-input
            v-model="row.scope.square"
            oninput="value=value.replace(/[^0-9.]/g, '')"
            placeholder="请输入方数"
            style="width: 100%"
          />
        </template>
        <template slot="weight" slot-scope="row">
          <el-input
            v-model="row.scope.weight"
            placeholder="请输入重量"
            oninput="value=value.replace(/[^0-9.]/g, '')"
            style="width: 100%"
          />
        </template>
        <template slot="opt" slot-scope="row">
          <el-button
            v-if="tableData.columns.length !== 1 && row.tIndex !== tableData.columns.length - 1"
            type="text"
            size="mini"
            @click="deleteRow(row.tIndex)"
          >删除</el-button
          >
          <el-button
            v-else
            type="text"
            size="mini"
            @click="addRow()"
          >新增行</el-button
          >
        </template>
      </BaseTable>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok()">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { saveMblSendWay, getMBLDetail } from '@/api/bill'
import { mapGetters } from 'vuex'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    editTableData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'containerId',
            label: '柜号',
            isRequired: true,
            isCustom: true
          },
          {
            filed: 'type',
            label: '派送方式',
            isRequired: true,
            isCustom: true
          },
          {
            filed: 'code',
            label: '仓库',
            isCustom: true
          },
          {
            filed: 'qty',
            label: '件数',
            isRequired: true,
            isCustom: true
          },
          {
            filed: 'square',
            label: '方数',
            isRequired: true,
            isCustom: true
          },
          {
            filed: 'weight',
            label: '重量',
            isRequired: true,
            isCustom: true
          },
          {
            filed: 'opt',
            label: '操作',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      sendwayOptions: [
        {
          label: 'UPS',
          value: 0
        },
        {
          label: 'FedEx',
          value: 1
        },
        {
          label: '亚马逊仓',
          value: 2
        },
        {
          label: '私仓',
          value: 3
        },
        {
          label: '自提',
          value: 4
        },
        {
          label: '留仓',
          value: 5
        },
        {
          label: '其它',
          value: 100
        },
        {
          label: 'USPS',
          value: 101
        },
        {
          label: '沃尔玛仓',
          value: 102
        }
        // {
        //   label: '自营仓',
        //   value: 103
        // }
      ],
      loading: false,
      contanierOptions: []
    }
  },
  computed: {
    ...mapGetters(['addressBookOptions'])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        if (this.editTableData.length > 0) {
          this.tableData.columns = [...this.editTableData]
        } else {
          this.tableData.columns = [
            {
              type: '',
              code: '',
              qty: '',
              square: '',
              weight: ''
            }
          ]
        }
        this.getMblContanier()
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    change(i) {
      // console.log(i)

      if (this.tableData.columns[i].type === 3) {
        const companyWarehouseList = (
          this.addressBookOptions[this.rowData.companyId] ||
          this.addressBookOptions[0]
        ).filter((a) => a.type === 0 && a.companyId === this.rowData.companyId)
        const arr = companyWarehouseList.map((item) => {
          item.label = `${item.code}-${item.companyName}`
          item.value = item.code
          return item
        })
        this.tableData.columns.splice(i, 1, {
          ...this.tableData.columns[i],
          codeOptions: arr
        })
      } else if (this.tableData.columns[i].type === 2) {
        const companyWarehouseList = (
          this.addressBookOptions[this.rowData.companyId] ||
          this.addressBookOptions[0]
        ).filter((a) => a.type === 1)
        const arr = companyWarehouseList.map((item) => {
          item.label = `${item.code}`
          item.value = item.code
          return item
        })
        this.tableData.columns.splice(i, 1, {
          ...this.tableData.columns[i],
          codeOptions: arr
        })
      }
    },
    async ok() {
      let flag = true
      let codeFlag = true
      this.tableData.columns.forEach((item) => {
        if (!item.qty || !item.square || !item.weight) {
          flag = false
        }
        if ((item.type === 2 || item.type === 3) && !item.code) {
          codeFlag = false
        }
      })
      if (!flag) {
        this.$message.error('请填写完整信息')
        return
      }
      if (!codeFlag) {
        this.$message.error('亚马逊仓或私仓必须填写仓库代码')
        return
      }
      this.loading = true
      try {
        const params = this.tableData.columns.map((item) => {
          if (item.type === 2 || item.type === 3) {
            const wareHouse = item.codeOptions.find(
              (a) => a.code === item.code
            )
            return {
              mblId: this.rowData.id,
              containerId: item.containerId,
              type: +item.type,
              qty: +item.qty,
              code: +item.code,
              square: +item.square,
              weight: +item.weight,
              ...wareHouse,
              id: this.editTableData.length > 0 ? item.id : undefined
            }
          } else {
            return {
              mblId: this.rowData.id,
              type: +item.type,
              qty: +item.qty,
              square: +item.square,
              weight: +item.weight,
              id: this.editTableData.length > 0 ? item.id : undefined
            }
          }
        })
        const res = await saveMblSendWay(params)
        this.loading = false
        if (res.success) {
          this.$message.success('添加派送方式成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    deleteRow(i) {
      this.tableData.columns.splice(i, 1)
    },
    addRow() {
      this.tableData.columns.push({
        type: '',
        code: '',
        qty: '',
        square: '',
        weight: ''
      })
    },
    async getMblContanier() {
      try {
        const res = await getMBLDetail({ mblId: this.rowData.id })
        if (res.success) {
          this.contanierOptions = res.data.pickUp?.sendWayItems?.map(item => {
            return {
              label: item.containerNo,
              value: item.containerId
            }
          })
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  height: auto;
  margin: 0 auto;
  text-align: left;
  .label {
    width: auto;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }
  .require {
    color: #ff7444;
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}

.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
